import React from "react";
import { useTranslation } from 'next-i18next';
import Image from "next/image";
import Slider, { Settings } from "react-slick";
import { Uppercase } from "styles/typography";
import { IntegrationsWrapper, ImageWrapper } from "./integrations.styles";
import { integrationsList } from "./integrations.utils";

const settings: Settings = {
   dots: false,
   autoplay: true,
   slidesToShow: 4,
   speed: 1000,
   autoplaySpeed: 4000,
   arrows: true,
   initialSlide: 0,
   infinite: true,
   responsive: [
      {
         breakpoint: 2000,
         settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: false,
            centerMode: true,
            centerPadding: "40",
            initialSlide: 3,
         },
      },
      {
         breakpoint: 1500,
         settings: {
            slidesToShow: 3.5,
            slidesToScroll: 1,
            arrows: true,
         },
      },
      {
         breakpoint: 1000,
         settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: true,
         },
      },
      {
         breakpoint: 500 || 400 || 300,
         settings: {
            slidesToShow: 1.5,
            slidesToScroll: 1,
            arrows: true,
         },
      },
   ],
};

const Integrations = () => {
   const { t } = useTranslation('common');
   return (
      <IntegrationsWrapper>
         <Uppercase center mw="1400">
            {t('integrations-title')}
         </Uppercase>

         <br />
         <Slider draggable accessibility {...settings}>
            {integrationsList.map((item) => (
               <ImageWrapper key={item.id}>
                  <Image src={item.icon} alt={item.alt} title={item.alt} />
               </ImageWrapper>
            ))}
         </Slider>
      </IntegrationsWrapper>
   );
};

export { Integrations };
